import React, { useState, useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Logout from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EmailIcon from '@mui/icons-material/Email';
import HttpsIcon from '@mui/icons-material/Https';
import DvrIcon from '@mui/icons-material/Dvr';
import MenuIcon from '@mui/icons-material/Menu';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import DescriptionIcon from '@mui/icons-material/Description';
import { SEVERITY } from '../../utils/Snackbar';
import { getAuthenticated, deleteStorage } from '../../utils/LocalStorage';
import { useNavigate } from "react-router";
import { post } from '../../utils/Api';
import Logo from '../Logo';

export default function Header(props) {
  const navigate = useNavigate();

  const [usuarioAdministrador,setUsuarioAdministrador] = useState(false);
  const [usuarioNomeSocial,setUsuarioNomeSocial] = useState('');
  const [usuarioEmail,setUsuarioEmail] = useState('');
  const [usuarioLogado,setUsuarioLogado] = useState(false);
  const [naoExibirMenu,setNaoExibirMenu] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const getUsuario = (callback) => {
    getAuthenticated(callback);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmail = () => {
    navigate('/redefinir-email');
    setAnchorEl(null);
  };

  const handleSenhas = () => {
    getUsuario((usuario)=>{
      navigate(`/usuario/${usuario.usuario_uuid}/senhas`);
      setAnchorEl(null);
    });
  };

  const handleGerenciarUsuarios = () => {
    navigate('/usuarios');
    setAnchorEl(null);
  };

  const handleExibirListarDocumentos = () => {
    navigate('/');
    setAnchorEl(null);
  };

  const handleAlterarUsuario = () => {
    getUsuario((usuario)=>{
      navigate(`/usuario/${usuario.usuario_uuid}`);
      setAnchorEl(null);
    });
  };

  const handleLogout = () => {
    setAnchorEl(null);

    props.setLoading(true);

    getUsuario((usuario)=>{
      post(`api/logout/${usuario.usuario_uuid}`,{},(json)=>{

        props.setLoading(false);

        if (json.deslogado) {
          props.handleMessage(json.mensagem,SEVERITY.SUCCESS.toString(),'',false);
          deleteStorage();
          window.location.href = '/';
        } else {
          props.handleMessage(json.mensagem,SEVERITY.WARNING.toString(),'',false);
        }

      },(error,message,severity)=>{
        props.setLoading(false);
        props.handleMessage(message,severity,error,true);
      });
    });
  };

  useEffect(()=>{
    getUsuario((usuario)=>{
      setUsuarioAdministrador(usuario.usuario_administrador);
      setUsuarioNomeSocial(usuario.usuario_nome_social);
      setUsuarioEmail(usuario.usuario_email);
      setUsuarioLogado(usuario.session_logado);

      if ( (props.naoExibirMenu !== undefined) && (props.naoExibirMenu !== null) && (props.naoExibirMenu === true) ) {
        setNaoExibirMenu(true);
      }
    });
  },[]);

  return (
    <AppBar
      position="static"
      sx={{
        backgroundImage: 'radial-gradient(#24142e, #3f3045)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Toolbar>
        <Logo version={props.version} />

        {
          (usuarioLogado && !naoExibirMenu) ? (
            <Box>
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open}
              >
                <MenuIcon
                  sx={{ width: 40, height: 40, color: '#fff' }}
                />
              </IconButton>
            </Box>
          ) : (<></>)
        }

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          slotProps={{
            paper: {
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          {
            (usuarioNomeSocial !== '') ? (
              <>
                <MenuItem  sx={{ color: '#1565c0', fontWeight: 'bold', pointerEvents: 'none' }}>
                  <ListItemIcon>
                    <AccountCircleIcon fontSize="small" sx={{ color: '#1565c0' }} />
                  </ListItemIcon>
                  {usuarioNomeSocial}
                </MenuItem>
                <Divider />
              </>
            ) : (<></>)
          }

          <MenuItem onClick={handleEmail}>
            <ListItemIcon>
              <EmailIcon fontSize="small" />
            </ListItemIcon>
            Alterar e-mail
          </MenuItem>
          <MenuItem onClick={handleAlterarUsuario}>
            <ListItemIcon>
              <ManageAccountsIcon fontSize="small" />
            </ListItemIcon>
            Alterar nome
          </MenuItem>
          <MenuItem onClick={handleSenhas}>
            <ListItemIcon>
              <HttpsIcon fontSize="small" />
            </ListItemIcon>
            Alterar senha
          </MenuItem>

          {
            (usuarioAdministrador) ? (
              <MenuItem onClick={handleGerenciarUsuarios}>
                <ListItemIcon>
                  <PersonAdd fontSize="small" />
                </ListItemIcon>
                Gerenciar usuários
              </MenuItem>
            ) : (<></>)
          }

          <MenuItem onClick={handleExibirListarDocumentos}>
            <ListItemIcon>
              <DescriptionIcon fontSize="small" />
            </ListItemIcon>
            Listar Documentos
          </MenuItem>

          {
            (usuarioEmail === 'lgapontes@gmail.com') ? (
              <>
                <MenuItem onClick={()=>{
                  navigate('/logging');
                }}>
                  <ListItemIcon>
                    <DvrIcon fontSize="small" />
                  </ListItemIcon>
                  Visualizar Logging
                </MenuItem>
                <MenuItem onClick={()=>{
                  navigate('/status');
                }}>
                  <ListItemIcon>
                    <RecentActorsIcon fontSize="small" />
                  </ListItemIcon>
                  Usuários logados
                </MenuItem>
              </>
            ) : (<></>)
          }

          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
